<template>
  <v-container style="height: 100%">
    <v-row align="center" justify="center" style="height: 100%">
      <v-col cols="12" sm="12">
        <v-card class="elevation-6 mt-6 fill-height">
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-row>
                <v-col cols="12" md="6">
                  <v-card-text class="mt-12">
                    <h4 class="text-center">Connectez-vous à votre compte</h4>
                    <h6 class="text-center  grey--text ">
                      Connectez-vous à votre compte et continuer <br />à
                      partager vos créations.
                    </h6>
                    <br /><br />
                    <v-row align="center" justify="center">
                      <v-col cols="12" sm="8">
                        <v-form
                          ref="loginForm"
                          v-model="valid"
                          lazy-validation
                          @submit.prevent="submit"
                        >
                          <v-text-field
                            v-model="loginEmail"
                            label="Email"
                            required
                            outlined
                            dense
                            color="teal accent-3"
                          ></v-text-field>

                          <v-text-field
                            v-model="loginPassword"
                            label="Mot de passe"
                            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="showPass = !showPass"
                            required
                            outlined
                            dense
                            color="teal accent-3"
                            :type="showPass ? 'text' : 'password'"
                          ></v-text-field>
                        </v-form>

                        <v-row>
                          <v-col cols="12" sm="7">
                            <!--<v-checkbox

                              label="Remember Me"
                              class="mt-n1"
                              color="blue"
                            > </v-checkbox>-->
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-dialog
                              v-model="dialogForgottenPassword"
                              persistent
                              max-width="600px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  class="caption blue--text"
                                  v-bind="attrs"
                                  v-on="on"
                                  >Mot de passe oublié ?</span
                                >
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="text-h5"
                                    >Réinitialisation du mot de passe</span
                                  >
                                </v-card-title>
                                <v-card-text>
                                  <transition name="fade">
                                    <p
                                      class="bg-red-100 p-5 my-5 border border-red-200 rounded text-red-500"
                                      v-if="error"
                                    >
                                      {{ error }}
                                    </p>
                                  </transition>
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                          v-model="passwdEmail"
                                          :rules="loginEmailRules"
                                          label="E-mail"
                                          required
                                          @keydown.enter="
                                            sendEmailForgottenPassword
                                          "
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="blue darken-1"
                                    text
                                    @click="dialogForgottenPassword = false"
                                  >
                                    Annuler
                                  </v-btn>
                                  <v-btn
                                    color="blue darken-1"
                                    text
                                    :disabled="!validEmailPasswd || loading"
                                    :loading="emailSending"
                                    @click="sendEmailForgottenPassword"
                                  >
                                    Valider
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-col>
                        </v-row>
                        <br />
                        <v-btn
                          color="blue"
                          @click="submit"
                          :disabled="this.isNotEmpty"
                          block
                          tile
                          >Se connecter</v-btn
                        >

                        <h5 class="text-center  grey--text mt-4 mb-3">
                          <br />
                        </h5>
                        <div
                          class="d-flex  justify-space-between align-center mx-10 mb-16"
                        >
                          <br />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="6" class="blue-grey rounded-bl-xl">
                  <div class="text-sm-center" style="padding: 130px 0 0;">
                    <v-img
                      class="mx-auto"
                      :max-height="'100'"
                      :max-width="'150'"
                      :lazy-src="logo"
                      :src="logo"
                    ></v-img>
                  </div>

                  <div style="  text-align: center; padding: 30px 0;">
                    <v-card-text class="white--text">
                      <h3 class="text-center ">
                        Vous n'avez pas encore de compte ?
                      </h3>
                      <h6 class="text-center"><br /><br /></h6>
                    </v-card-text>
                    <div class="text-center">
                      <v-btn tile outlined dark @click="step++"
                        >Créer un compte</v-btn
                      >
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>
            <v-window-item :value="2">
              <v-row>
                <v-col cols="12" md="6" class="blue-grey rounded-br-xl">
                  <div class="text-sm-center" style="padding: 130px 0 0;">
                    <v-img
                      class="mx-auto"
                      :max-height="'100'"
                      :max-width="'150'"
                      :lazy-src="logo"
                      :src="logo"
                    ></v-img>
                  </div>

                  <div style="  text-align: center; padding: 30px 0;">
                    <v-card-text class="white--text">
                      <h3 class="text-center ">Vous avez déjà un compte ?</h3>
                      <h6 class="text-center">
                        Connectez-vous à votre compte et continuer <br />à
                        partager vos créations.
                      </h6>
                    </v-card-text>
                    <div class="text-center">
                      <v-btn tile outlined dark @click="step--"
                        >Se connecter</v-btn
                      >
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card-text>
                    <h4 class="text-center">Création d'un compte</h4>
                    <h6 class="text-center  grey--text "><br /></h6>
                    <v-form ref="registerForm" v-model="valid" lazy-validation>
                      <v-row align="center" justify="center">
                        <v-col cols="12" sm="12">
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="firstName"
                                :rules="[rules.required]"
                                label="Prénom"
                                maxlength="20"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="lastName"
                                :rules="[rules.required]"
                                label="Nom"
                                maxlength="20"
                                required
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-text-field
                            v-model="email"
                            :rules="[rules.required, emailRules]"
                            label="E-mail"
                            outlined
                            dense
                          ></v-text-field>
                          <v-autocomplete
                            v-model="country"
                            :items="[
                              'France',
                              'Canada',
                              'Belgique',
                              'Suisse',
                              'Luxembourg',
                              'Autre'
                            ]"
                            label="Dans quel pays exercez-vous ?"
                            :rules="[rules.required]"
                            outlined
                            dense
                          ></v-autocomplete>
                          <v-autocomplete
                            v-model="professionalStatus"
                            :items="[
                              'Neuropsychologue libéral',
                              'Neuropsychologue en institution',
                              'Enseignant chercheur en sciences cognitives/neuropsychologie',
                              'Doctorant',
                              'Étudiant en master 2 neuropsychologie'
                            ]"
                            label="Statut professionnel"
                            :rules="[rules.required]"
                            outlined
                            dense
                          ></v-autocomplete>
                          <v-autocomplete
                            v-model="university"
                            :items="[
                              'Aix Marseille',
                              'Amiens (Picardie Jules Verne)',
                              'Angers',
                              'Besançon (Franche-Comté)',
                              'Bordeaux',
                              'Brest',
                              'Caen',
                              'Chambéry',
                              'Grenoble',
                              'Lille 3',
                              'Lyon 2',
                              'Montpellier',
                              'Nancy 2',
                              'Nantes',
                              'Nice',
                              'Paris 5',
                              'Paris 8',
                              'Paris Nanterre',
                              'Poitiers',
                              'Reims',
                              'Rouen',
                              'Strasbourg',
                              'Toulouse 2',
                              'Tours',
                              'Autre ville Française',
                              'Canada',
                              'Belgique',
                              'Suisse',
                              'Luxembourg',
                              'Autre pays'
                            ]"
                            label="Dans quelle université avez-vous étudié ou étudiez-vous actuellement ?"
                            :rules="[rules.required]"
                            outlined
                            dense
                          ></v-autocomplete>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                v-model="password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show1 ? 'text' : 'password'"
                                name="input-10-1"
                                label="Mot de passe"
                                hint="Au moins 8 caractères"
                                dense
                                outlined
                                @click:append="show1 = !show1"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                block
                                outlined
                                v-model="verify"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, passwordMatch]"
                                :type="show1 ? 'text' : 'password'"
                                name="input-10-1"
                                label="Répéter le mot de passe"
                                dense
                                @click:append="show1 = !show1"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <div
                                style="min-height: 150px;overflow-x:auto;max-height: 150px;background-color: white"
                              >
                                <h3>
                                  Inscription sur R’Cog, plateforme spécialisée
                                  en partage d’activités en intervention
                                  cognitive pour les neuropsychologues.
                                </h3>
                                <span>
                                  <p>
                                    Merci de prendre un moment pour lire les
                                    informations suivantes.
                                  </p>
                                  <p>
                                    Lorsque vous créez votre compte R’Cog, vous
                                    devez nous fournir des informations exactes
                                    et complètes. Pour utiliser R’Cog, vous
                                    devez d'abord accepter les conditions
                                    d'utilisation. Vous ne pouvez pas utiliser
                                    R’Cog si vous n'acceptez pas les conditions
                                    d'utilisation.
                                  </p>
                                  <p>
                                    R’Cog est réservé aux psychologues et
                                    étudiants en deuxième année de master de
                                    psychologie ayant une spécialité en
                                    neuropsychologie. Pour pouvoir utiliser
                                    pleinement R’Cog une validation de votre
                                    statut est nécessaire, elle s'effectue
                                    manuellement par un des deux administrateurs
                                    du site après examen complet de vos
                                    justificatifs (numéro d’inscription au
                                    répertoire ADELI et photo du diplôme). Ces
                                    documents servent uniquement à la validation
                                    de l’inscription, ils sont ensuite effacés
                                    de notre base de données dans les 30 jours
                                    qui suivent l’inscription.
                                  </p>
                                  <p>
                                    R’Cog est une plateforme indépendante qui
                                    n'est subventionnée par aucune instance.
                                  </p>
                                  <p>
                                    Veuillez prendre un moment pour lire la
                                    charte de l’utilisateur que vous trouverez
                                    <a href="/about">ici</a>.
                                  </p>
                                  <p>
                                    Rappelez-vous que nous ne sommes pas
                                    responsables des commentaires postés par les
                                    membres. Nous ne sommes pas responsables du
                                    contenu des commentaires et ne pouvons en
                                    garantir ni la pertinence ni l’exactitude.
                                    Nous avons la possibilité de supprimer, dans
                                    un temps raisonnable, les commentaires qui
                                    ne répondent pas aux conditions de la charte
                                    d’utilisation et si nous estimons que cette
                                    suppression est nécessaire.
                                  </p>
                                  <p>
                                    Vous acceptez, par votre utilisation de ce
                                    service, de ne pas poster des messages ou
                                    commentaires qui seraient sciemment faux
                                    et/ou diffamatoires, imprécis, abusifs,
                                    vulgaires, haineux, harcelants, obscènes,
                                    profanes, sexuellement orientés, menaçants,
                                    envahissants pour la vie privée d’une
                                    personne ou contraires à la loi.
                                  </p>
                                  <p>
                                    En vous inscrivant sur R’Cog vous acceptez
                                    l’utilisation du Creative Commons pour
                                    partager vos activités gratuitement. Vous ne
                                    pouvez poster aucun contenu sous copyright,
                                    sauf si le droit d’auteur est détenu par
                                    vous-même.
                                  </p>
                                  <p>
                                    R’Cog utilise des cookies pour vous
                                    distinguer des autres utilisateurs et nous
                                    permet de vous offrir une expérience
                                    personnalisée lorsque vous naviguez sur ce
                                    site.
                                  </p>
                                  <p><b>Bonne navigation ! </b></p>
                                </span>
                              </div>
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model="terms"
                                :rules="[rules.required]"
                                label="J'ai lu et j'accepte les termes et conditions."
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                          <v-btn
                            color="blue"
                            block
                            tile
                            :disabled="!valid"
                            @click="register"
                            >S'inscrire</v-btn
                          >
                          <h5 class="text-center  grey--text mt-4 mb-3"></h5>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const firebase = require("../../firebase.config.js");
import { init, send } from "@emailjs/browser";

import { required, email } from "vee-validate/dist/rules";
import { EventBus } from "@/eventBus";

import {
  extend,
  //ValidationProvider,
  setInteractionMode
  //ValidationObserver
} from "vee-validate";
import { getTranslation } from "firebase-error-translator";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} ne peut être null"
});

extend("email", {
  ...email,
  message: "L'adresse E-mail doit être valide"
});

export default {
  data: () => ({
    email: "",
    password: null,
    showPass: false,
    country: "",
    signupForm: false,
    loginEmailRules: [
      v => !!v || "Ce champ est requis",
      v => /.+@.+\..+/.test(v) || "L'adresse E-mail doit être valide"
    ],
    emailRules: [
      v => !!v || "Required",
      v => /.+@.+\..+/.test(v) || "L'adresse E-mail doit être valide"
    ],
    rules: {
      required: value => !!value || "Ce champ est requis",
      min: v => (v && v.length >= 8) || "8 caractères minimum"
    },
    valid: true,
    validEmailPasswd: true,
    firstName: "",
    show1: false,
    lastName: "",
    passwdEmail: "",
    emailSending: false,
    emailSendOk: false,
    professionalStatus: "",
    error: false,
    verify: "",
    loginPassword: "",
    loginEmail: "",
    loading: false,
    university: "",
    terms: false,
    sendingEmailText: "",
    step: 1,
    logo: require("@/assets/logo_rcog.svg"),
    dialogForgottenPassword: false
  }),
  props: {
    source: String
  },
  computed: {
    ...mapGetters({
      userDisabled: "user/isUserDisabled",
      user: "user/getUser"
    }),
    params() {
      return {
        email: this.email.toLowerCase(),
        password: this.password
      };
    },
    passwordMatch() {
      return () =>
        this.password === this.verify ||
        "Les mots de passe doivent être identiques.";
    },
    isNotEmpty() {
      return !(this.loginEmail && this.loginPassword);
    }
  },
  watch: {
    dialogForgottenPassword: function() {
      this.dialog = !this.dialog;
    }
  },
  methods: {
    ...mapActions({
      registeredDone: "user/registeredDone",
      fetchUser: "user/fetchUser",
      fetchActivities: "activities/fetchActivities"
    }),
    async submit() {
      this.login(this.params); // action to login
    },
    sendEmailForgottenPassword() {
      if (!this.passwdEmail) {
        this.error = "Veuillez entrer une adresse email valide";
        return;
      }
      this.error = null;
      this.emailSending = true;
      firebase
        .auth()
        .sendPasswordResetEmail(this.passwdEmail.toLowerCase())
        .then(() => {
          this.emailSending = false;
          this.dialogForgottenPassword = false;
          this.sendingEmailText =
            "Un email de réinitialisation vous a été envoyé. N'oubliez pas de regarder dans vos spams.";
          this.emailSendOk = true;
        })
        .catch(error => {
          this.emailSending = false;
          if (error.code === "auth/user-not-found") {
            this.error = "Cette adresse mail n'est pas reconnue.";
          } else this.error = error.message;
        });
    },
    async login() {
      if (this.$refs.loginForm.validate()) {
        firebase
          .auth()
          .signInWithEmailAndPassword(
            this.loginEmail.toLowerCase(),
            this.loginPassword
          )
          // eslint-disable-next-line no-unused-vars
          .then(async data => {
            await firebase.usersCollection
              .doc(this.loginEmail.toLowerCase())
              .onSnapshot(querySnapshot => {
                const user = querySnapshot.data();
                user.uid = data.user.uid;
                user.email = this.loginEmail.toLowerCase();
                this.fetchUser(user);
                if (!user.disable) {
                  this.fetchActivities();
                  this.$router.replace({ name: "Home" });
                } else {
                  firebase.auth().signOut();
                  this.$router.replace({ name: "SuccessfullRegistration" });
                }
              });
          })
          .catch(err => {
            EventBus.$emit("showSnackBar", {
              message: `${getTranslation(err.code).toString()}\n`,
              type: "error"
            });
            this.error = err.message;
          });
      }
    },
    async register() {
      if (this.$refs.registerForm.validate()) {
        await firebase
          .auth()
          .createUserWithEmailAndPassword(
            this.email.toLowerCase(),
            this.password
          )
          .then(data => {
            data.user.updateProfile({
              displayName: this.firstName + " " + this.lastName
            });
            EventBus.$emit("showSnackBar", {
              message: `Félicitations votre compte a été créé`,
              type: "success"
            });
            return data;
          })
          .catch(err => {
            //this.error = err.message;
            EventBus.$emit("showSnackBar", {
              message: `${getTranslation(err.message).toString()}\n`,
              type: "error"
            });
          });

        await firebase.usersCollection
          .doc(this.email.toLowerCase())
          .set({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email.toLowerCase(),
            likes: 0,
            fav: 0,
            country: this.country,
            professionalStatus: this.professionalStatus,
            terms: this.terms,
            university: this.university,
            disable: true,
            created_on: new Date()
          })
          // eslint-disable-next-line no-unused-vars
          .then(data => {
            init("user_yBUvBgsuDyOpxKu5oLYfM");
            send("service_o2b3phj", "template_vfyaj5j", {
              name: this.firstName,
              email: this.email.toLowerCase()
            });
          });
        firebase.auth().signOut();
        this.$router.replace({ name: "SuccessfullRegistration" });
      }
    },
    clear() {
      // you can use this method to clear login form
      this.email = "";
      this.password = null;
      this.$refs.observer.reset();
    }
  }
};
</script>
<style scoped>
.v-application .rounded-bl-xl {
  border-bottom-left-radius: 300px !important;
}
.v-application .rounded-br-xl {
  border-bottom-right-radius: 300px !important;
}
</style>
